// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.
import React from 'react';
import ChatBot from '../components/ChatBot';
import './Services.css';

const ChatBotPage = () => {
  return (
    <div className="service-page">
      <h1>AI Assistant</h1>
      <p className="service-description">
        Ask me anything about the platform, AI services, or how to accomplish specific tasks. 
        I'm here to help!
      </p>
      <ChatBot />
    </div>
  );
};

export default ChatBotPage;
